module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    key: "relatedItem",
    staticClass: "modal-mask",
    attrs: {
      "id": "related-item"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper _modalWrapper_"
  }, [_c('div', {
    staticClass: "modal-container flexContainer"
  }, [_c('div', {
    staticClass: "modalBody"
  }, [_c('h2', {
    staticClass: "listTitle ff-medium uppercase txtCenter"
  }, [_vm._v(_vm._s(_vm.$t("abonnement.title")) + " : " + _vm._s(_vm.$t("abonnement.diffusion")))]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "form-group row"
  }, [_c('table', {
    staticClass: "table-borderless"
  }, [_c('tbody', [_vm._l((_vm.diffusionUser), function(n, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(n.firstbame) + " " + _vm._s(n.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(n.email))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "id": "newInputName"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "id": "newInputEmail"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "id": "newInputBrand"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "id": "save"
    },
    on: {
      "click": function($event) {
        _vm.saveAdded();
      }
    }
  })])], 2)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flexContainer fright"
  }, [_c('button', {
    staticClass: "btn uppercase",
    on: {
      "click": function($event) {
        _vm.close();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("abonnement.previous")))])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e5e4c89","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/Diffusion.vue
// module id = 3100
// module chunks = 0